import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Box,
  Button,
  ButtonGroup,
  HStack,
  IconButton,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useRef } from 'react';
import { FaPen, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { deleteOrg } from '../../../stores/slices/organisations/organisationsActions';
import DeleteAlert from '../../Alerts/DeleteAlert';
import OrganisationModal from './OrganisationModal';
import OrgUsers from './OrgUsers';

const OrganisationsList = () => {
  const { organisations } = useSelector(state => state.organisations);
  const [toUpdate, setToUpdate] = useState({
    state: false,
    organisation: null,
  });
  const { state } = useLocation();
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const {
    isOpen: isOpenAlertOverride,
    onOpen: onOpenAlertOverride,
    onClose: onCloseAlertOverride,
  } = useDisclosure();
  const dispatch = useDispatch();
  const toast = useToast();
  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, organisation: null });
  };

  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteOrg({ orgId: selectedOrg.id }));
    onCloseAlert();
    setIsDeleting(false);
    setSelectedOrg(null);
    if (res.type === 'organisations/deleteOrg/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      toast({
        description: 'Organisation has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <React.Fragment>
      <Accordion
        defaultIndex={
          state
            ? state.refId
              ? organisations.findIndex(org => org.id === state.refId)
              : 0
            : 0
        }
        allowToggle
      >
        {organisations.map(org => (
          <AccordionItem key={org.id}>
            {({ isExpanded }) => (
              <React.Fragment>
                <HStack
                  spacing={0}
                  backgroundColor={isExpanded ? 'primaryOpaque' : 'none'}
                  _hover={{ background: 'primaryOpaque', color: 'primary' }}
                >
                  <AccordionButton
                    _expanded={{ color: 'primary', fontWeight: 'bold' }}
                    _hover={{ background: 'none' }}
                  >
                    <Box flex="1" textAlign="left">
                      {org.name}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <ButtonGroup spacing={'1'}>
                    <IconButton
                      aria-label="Edit"
                      icon={<FaPen />}
                      variant={'outline'}
                      size="sm"
                      color={'primary'}
                      onClick={() => {
                        setToUpdate({
                          state: true,
                          organisation: org,
                        });
                        onOpen();
                      }}
                    />
                    <IconButton
                      aria-label="Delete"
                      icon={<FaTimes />}
                      variant={'outline'}
                      size="sm"
                      color={'red.400'}
                      onClick={() => {
                        if (org.users_count > 0) {
                          onOpenAlertOverride();
                        } else {
                          setSelectedOrg(org);
                          onOpenAlert();
                        }
                      }}
                    />
                  </ButtonGroup>
                </HStack>
                <AccordionPanel pb={4}>
                  <OrgUsers organisation={org} />
                </AccordionPanel>
              </React.Fragment>
            )}
          </AccordionItem>
        ))}
      </Accordion>
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete organisation?`}
        body={"Are you sure? If you delete this record, it'll be gone forever."}
        onDeleteItem={onDeleteItem}
      />
      {isOpenAlertOverride && (
        <AlertDialog
          isOpen={isOpenAlertOverride}
          leastDestructiveRef={cancelRef}
          onClose={onCloseAlertOverride}
          blockScrollOnMount={false}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogBody mt={'4'}>
                You must remove all users from the Organisation before you can
                delete.
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  variant={'outline'}
                  onClick={onCloseAlertOverride}
                >
                  Ok
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      )}
      {isOpen && (
        <OrganisationModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default OrganisationsList;
